import {Dialog, IconButton} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import styles from './FullScreenPopup.module.scss';

interface Props {
  children: React.ReactNode;
  header: React.ReactNode;
  popupState: {
    open: boolean;
    setOpen: (open: boolean) => void;
  }
}

const FullScreenPopup = ({children, header, popupState}: Props): React.ReactElement => {
  const {open, setOpen} = popupState;

  const handleClose = (): void => setOpen(false);

  return (
    <>
      <Dialog fullScreen open={open} onClose={handleClose}>
        <div className={styles.content}>
          <div className={styles.header}>
            {header}
            <IconButton edge='start'
                        color='inherit'
                        onClick={handleClose}
                        aria-label='close'>
              <CloseIcon className={styles.closeIcon} />
            </IconButton>
          </div>
          {children}
        </div>
      </Dialog>
    </>
  );
};

export default FullScreenPopup;